import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDragDropLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 126,
	height: 100,
	viewBox: "0 0 126 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_10849_900175)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemBody",
				d: "M66.9383 24.8398H12.063C10.5594 24.8398 9.34058 26.0587 9.34058 27.5623V32.6868C9.34058 34.1904 10.5594 35.4092 12.063 35.4092H66.9383C68.4418 35.4092 69.6607 34.1904 69.6607 32.6868V27.5623C69.6607 26.0587 68.4418 24.8398 66.9383 24.8398Z",
				fill: "#373D62"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemZone",
				d: "M9.50073 27.5622C9.50073 26.1471 10.648 24.9999 12.0631 24.9999H14.9456V35.249H12.0631C10.648 35.249 9.50073 34.1018 9.50073 32.6867V27.5622Z",
				fill: "#404772"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragDots",
				d: "M12.1693 31.4056C12.1693 31.6405 11.9772 31.8327 11.7423 31.8327C11.5074 31.8327 11.3152 31.6405 11.3152 31.4056C11.3152 31.1708 11.5074 30.9786 11.7423 30.9786C11.9772 30.9786 12.1693 31.1708 12.1693 31.4056ZM11.7423 29.6974C11.5074 29.6974 11.3152 29.8896 11.3152 30.1245C11.3152 30.3594 11.5074 30.5515 11.7423 30.5515C11.9772 30.5515 12.1693 30.3594 12.1693 30.1245C12.1693 29.8896 11.9772 29.6974 11.7423 29.6974ZM11.7423 28.4163C11.5074 28.4163 11.3152 28.6085 11.3152 28.8434C11.3152 29.0782 11.5074 29.2704 11.7423 29.2704C11.9772 29.2704 12.1693 29.0782 12.1693 28.8434C12.1693 28.6085 11.9772 28.4163 11.7423 28.4163ZM13.0234 29.2704C13.2583 29.2704 13.4505 29.0782 13.4505 28.8434C13.4505 28.6085 13.2583 28.4163 13.0234 28.4163C12.7885 28.4163 12.5964 28.6085 12.5964 28.8434C12.5964 29.0782 12.7885 29.2704 13.0234 29.2704ZM13.0234 29.6974C12.7885 29.6974 12.5964 29.8896 12.5964 30.1245C12.5964 30.3594 12.7885 30.5515 13.0234 30.5515C13.2583 30.5515 13.4505 30.3594 13.4505 30.1245C13.4505 29.8896 13.2583 29.6974 13.0234 29.6974ZM13.0234 30.9786C12.7885 30.9786 12.5964 31.1708 12.5964 31.4056C12.5964 31.6405 12.7885 31.8327 13.0234 31.8327C13.2583 31.8327 13.4505 31.6405 13.4505 31.4056C13.4505 31.1708 13.2583 30.9786 13.0234 30.9786Z",
				fill: "#6C75AC"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragTextZone",
				d: "M29.5298 26.9216H18.7897C18.0821 26.9216 17.5085 27.4952 17.5085 28.2028V32.0462C17.5085 32.7537 18.0821 33.3273 18.7897 33.3273H29.5298C30.2374 33.3273 30.8109 32.7537 30.8109 32.0462V28.2028C30.8109 27.4952 30.2374 26.9216 29.5298 26.9216Z",
				fill: "#404772"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0_10849_900175",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 55,
				y: 27,
				width: 10,
				height: 6,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M61.815 27.5623H57.7153C56.3002 27.5623 55.1531 28.7094 55.1531 30.1245C55.1531 31.5396 56.3002 32.6868 57.7153 32.6868H61.815C63.2301 32.6868 64.3772 31.5396 64.3772 30.1245C64.3772 28.7094 63.2301 27.5623 61.815 27.5623Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask0_10849_900175)",
				children: [/* @__PURE__ */ _jsx("path", {
					className: "switch",
					d: "M61.815 27.5623H57.7153C56.3002 27.5623 55.1531 28.7094 55.1531 30.1245C55.1531 31.5396 56.3002 32.6868 57.7153 32.6868H61.815C63.2301 32.6868 64.3772 31.5396 64.3772 30.1245C64.3772 28.7094 63.2301 27.5623 61.815 27.5623Z",
					fill: "#6674CC"
				}), /* @__PURE__ */ _jsx("g", {
					filter: "url(#filter0_dd_10849_900175)",
					children: /* @__PURE__ */ _jsx("path", {
						className: "switchDot",
						d: "M61.8142 32.1743C62.9463 32.1743 63.864 31.2566 63.864 30.1245C63.864 28.9924 62.9463 28.0747 61.8142 28.0747C60.6821 28.0747 59.7644 28.9924 59.7644 30.1245C59.7644 31.2566 60.6821 32.1743 61.8142 32.1743Z",
						fill: "#CED1E3"
					})
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemBorder",
				d: "M66.9383 24.8398H12.063C10.5594 24.8398 9.34058 26.0587 9.34058 27.5623V32.6868C9.34058 34.1904 10.5594 35.4092 12.063 35.4092H66.9383C68.4418 35.4092 69.6607 34.1904 69.6607 32.6868V27.5623C69.6607 26.0587 68.4418 24.8398 66.9383 24.8398Z",
				stroke: "#404772",
				strokeWidth: .320284
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .5,
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "dragItemBody",
						d: "M121.938 38.8398H67.063C65.5594 38.8398 64.3406 40.0587 64.3406 41.5623V46.6868C64.3406 48.1904 65.5594 49.4092 67.063 49.4092H121.938C123.442 49.4092 124.661 48.1904 124.661 46.6868V41.5623C124.661 40.0587 123.442 38.8398 121.938 38.8398Z",
						fill: "#373D62"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "dragItemZone",
						d: "M64.5007 41.5623C64.5007 40.1472 65.6479 39 67.063 39H69.9455V49.2491H67.063C65.6479 49.2491 64.5007 48.1019 64.5007 46.6868V41.5623Z",
						fill: "#404772"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "dragDots",
						d: "M67.1693 45.4057C67.1693 45.6406 66.9772 45.8328 66.7423 45.8328C66.5074 45.8328 66.3152 45.6406 66.3152 45.4057C66.3152 45.1709 66.5074 44.9787 66.7423 44.9787C66.9772 44.9787 67.1693 45.1709 67.1693 45.4057ZM66.7423 43.6976C66.5074 43.6976 66.3152 43.8897 66.3152 44.1246C66.3152 44.3595 66.5074 44.5516 66.7423 44.5516C66.9772 44.5516 67.1693 44.3595 67.1693 44.1246C67.1693 43.8897 66.9772 43.6976 66.7423 43.6976ZM66.7423 42.4164C66.5074 42.4164 66.3152 42.6086 66.3152 42.8435C66.3152 43.0783 66.5074 43.2705 66.7423 43.2705C66.9772 43.2705 67.1693 43.0783 67.1693 42.8435C67.1693 42.6086 66.9772 42.4164 66.7423 42.4164ZM68.0234 43.2705C68.2583 43.2705 68.4505 43.0783 68.4505 42.8435C68.4505 42.6086 68.2583 42.4164 68.0234 42.4164C67.7885 42.4164 67.5964 42.6086 67.5964 42.8435C67.5964 43.0783 67.7885 43.2705 68.0234 43.2705ZM68.0234 43.6976C67.7885 43.6976 67.5964 43.8897 67.5964 44.1246C67.5964 44.3595 67.7885 44.5516 68.0234 44.5516C68.2583 44.5516 68.4505 44.3595 68.4505 44.1246C68.4505 43.8897 68.2583 43.6976 68.0234 43.6976ZM68.0234 44.9787C67.7885 44.9787 67.5964 45.1709 67.5964 45.4057C67.5964 45.6406 67.7885 45.8328 68.0234 45.8328C68.2583 45.8328 68.4505 45.6406 68.4505 45.4057C68.4505 45.1709 68.2583 44.9787 68.0234 44.9787Z",
						fill: "#6C75AC"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "dragTextZone",
						d: "M84.5298 40.9216H73.7897C73.0821 40.9216 72.5085 41.4952 72.5085 42.2028V46.0462C72.5085 46.7537 73.0821 47.3273 73.7897 47.3273H84.5298C85.2374 47.3273 85.811 46.7537 85.811 46.0462V42.2028C85.811 41.4952 85.2374 40.9216 84.5298 40.9216Z",
						fill: "#404772"
					}),
					/* @__PURE__ */ _jsx("mask", {
						id: "mask1_10849_900175",
						style: { maskType: "luminance" },
						maskUnits: "userSpaceOnUse",
						x: 110,
						y: 41,
						width: 10,
						height: 6,
						children: /* @__PURE__ */ _jsx("path", {
							d: "M116.815 41.5623H112.715C111.3 41.5623 110.153 42.7094 110.153 44.1245C110.153 45.5396 111.3 46.6868 112.715 46.6868H116.815C118.23 46.6868 119.377 45.5396 119.377 44.1245C119.377 42.7094 118.23 41.5623 116.815 41.5623Z",
							fill: "white"
						})
					}),
					/* @__PURE__ */ _jsxs("g", {
						mask: "url(#mask1_10849_900175)",
						children: [/* @__PURE__ */ _jsx("path", {
							className: "switch",
							d: "M116.815 41.5623H112.715C111.3 41.5623 110.153 42.7094 110.153 44.1245C110.153 45.5396 111.3 46.6868 112.715 46.6868H116.815C118.23 46.6868 119.377 45.5396 119.377 44.1245C119.377 42.7094 118.23 41.5623 116.815 41.5623Z",
							fill: "#6674CC"
						}), /* @__PURE__ */ _jsx("g", {
							filter: "url(#filter1_dd_10849_900175)",
							children: /* @__PURE__ */ _jsx("path", {
								className: "switchDot",
								d: "M116.814 46.1743C117.946 46.1743 118.864 45.2566 118.864 44.1245C118.864 42.9924 117.946 42.0747 116.814 42.0747C115.682 42.0747 114.764 42.9924 114.764 44.1245C114.764 45.2566 115.682 46.1743 116.814 46.1743Z",
								fill: "#CED1E3"
							})
						})]
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "dragItemBorder",
						d: "M121.938 38.8398H67.063C65.5594 38.8398 64.3406 40.0587 64.3406 41.5623V46.6868C64.3406 48.1904 65.5594 49.4092 67.063 49.4092H121.938C123.442 49.4092 124.661 48.1904 124.661 46.6868V41.5623C124.661 40.0587 123.442 38.8398 121.938 38.8398Z",
						stroke: "#404772",
						strokeWidth: .320284
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemBody",
				d: "M121.938 63.8398H67.063C65.5594 63.8398 64.3406 65.0587 64.3406 66.5623V71.6868C64.3406 73.1904 65.5594 74.4092 67.063 74.4092H121.938C123.442 74.4092 124.661 73.1904 124.661 71.6868V66.5623C124.661 65.0587 123.442 63.8398 121.938 63.8398Z",
				fill: "#373D62"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemZone",
				d: "M64.5007 66.5622C64.5007 65.1471 65.6479 63.9999 67.063 63.9999H69.9455V74.249H67.063C65.6479 74.249 64.5007 73.1018 64.5007 71.6867V66.5622Z",
				fill: "#404772"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragDots",
				d: "M67.1693 70.4056C67.1693 70.6405 66.9772 70.8327 66.7423 70.8327C66.5074 70.8327 66.3152 70.6405 66.3152 70.4056C66.3152 70.1708 66.5074 69.9786 66.7423 69.9786C66.9772 69.9786 67.1693 70.1708 67.1693 70.4056ZM66.7423 68.6975C66.5074 68.6975 66.3152 68.8896 66.3152 69.1245C66.3152 69.3594 66.5074 69.5515 66.7423 69.5515C66.9772 69.5515 67.1693 69.3594 67.1693 69.1245C67.1693 68.8896 66.9772 68.6975 66.7423 68.6975ZM66.7423 67.4163C66.5074 67.4163 66.3152 67.6085 66.3152 67.8434C66.3152 68.0782 66.5074 68.2704 66.7423 68.2704C66.9772 68.2704 67.1693 68.0782 67.1693 67.8434C67.1693 67.6085 66.9772 67.4163 66.7423 67.4163ZM68.0234 68.2704C68.2583 68.2704 68.4505 68.0782 68.4505 67.8434C68.4505 67.6085 68.2583 67.4163 68.0234 67.4163C67.7885 67.4163 67.5964 67.6085 67.5964 67.8434C67.5964 68.0782 67.7885 68.2704 68.0234 68.2704ZM68.0234 68.6975C67.7885 68.6975 67.5964 68.8896 67.5964 69.1245C67.5964 69.3594 67.7885 69.5515 68.0234 69.5515C68.2583 69.5515 68.4505 69.3594 68.4505 69.1245C68.4505 68.8896 68.2583 68.6975 68.0234 68.6975ZM68.0234 69.9786C67.7885 69.9786 67.5964 70.1708 67.5964 70.4056C67.5964 70.6405 67.7885 70.8327 68.0234 70.8327C68.2583 70.8327 68.4505 70.6405 68.4505 70.4056C68.4505 70.1708 68.2583 69.9786 68.0234 69.9786Z",
				fill: "#6C75AC"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragTextZone",
				d: "M84.5298 65.9216H73.7897C73.0821 65.9216 72.5085 66.4952 72.5085 67.2028V71.0462C72.5085 71.7537 73.0821 72.3273 73.7897 72.3273H84.5298C85.2374 72.3273 85.811 71.7537 85.811 71.0462V67.2028C85.811 66.4952 85.2374 65.9216 84.5298 65.9216Z",
				fill: "#404772"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask2_10849_900175",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 110,
				y: 66,
				width: 10,
				height: 6,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M116.815 66.5623H112.715C111.3 66.5623 110.153 67.7094 110.153 69.1245C110.153 70.5396 111.3 71.6868 112.715 71.6868H116.815C118.23 71.6868 119.377 70.5396 119.377 69.1245C119.377 67.7094 118.23 66.5623 116.815 66.5623Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask2_10849_900175)",
				children: [/* @__PURE__ */ _jsx("path", {
					className: "switch",
					d: "M116.815 66.5623H112.715C111.3 66.5623 110.153 67.7094 110.153 69.1245C110.153 70.5396 111.3 71.6868 112.715 71.6868H116.815C118.23 71.6868 119.377 70.5396 119.377 69.1245C119.377 67.7094 118.23 66.5623 116.815 66.5623Z",
					fill: "#6674CC"
				}), /* @__PURE__ */ _jsx("g", {
					filter: "url(#filter2_dd_10849_900175)",
					children: /* @__PURE__ */ _jsx("path", {
						className: "switchDot",
						d: "M116.814 71.1743C117.946 71.1743 118.864 70.2566 118.864 69.1245C118.864 67.9924 117.946 67.0747 116.814 67.0747C115.682 67.0747 114.764 67.9924 114.764 69.1245C114.764 70.2566 115.682 71.1743 116.814 71.1743Z",
						fill: "#CED1E3"
					})
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemBorder",
				d: "M121.938 63.8398H67.063C65.5594 63.8398 64.3406 65.0587 64.3406 66.5623V71.6868C64.3406 73.1904 65.5594 74.4092 67.063 74.4092H121.938C123.442 74.4092 124.661 73.1904 124.661 71.6868V66.5623C124.661 65.0587 123.442 63.8398 121.938 63.8398Z",
				stroke: "#404772",
				strokeWidth: .320284
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemBody",
				d: "M57.9383 38.8398H3.06299C1.55944 38.8398 0.340576 40.0587 0.340576 41.5623V46.6868C0.340576 48.1904 1.55944 49.4092 3.06299 49.4092H57.9383C59.4418 49.4092 60.6607 48.1904 60.6607 46.6868V41.5623C60.6607 40.0587 59.4418 38.8398 57.9383 38.8398Z",
				fill: "#373D62"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemZone",
				d: "M0.500732 41.5622C0.500732 40.1471 1.6479 38.9999 3.063 38.9999H5.94556V49.249H3.063C1.6479 49.249 0.500732 48.1018 0.500732 46.6867V41.5622Z",
				fill: "#404772"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragDots",
				d: "M3.16928 45.4056C3.16928 45.6405 2.97711 45.8327 2.74223 45.8327C2.50736 45.8327 2.31519 45.6405 2.31519 45.4056C2.31519 45.1708 2.50736 44.9786 2.74223 44.9786C2.97711 44.9786 3.16928 45.1708 3.16928 45.4056ZM2.74223 43.6975C2.50736 43.6975 2.31519 43.8896 2.31519 44.1245C2.31519 44.3594 2.50736 44.5515 2.74223 44.5515C2.97711 44.5515 3.16928 44.3594 3.16928 44.1245C3.16928 43.8896 2.97711 43.6975 2.74223 43.6975ZM2.74223 42.4163C2.50736 42.4163 2.31519 42.6085 2.31519 42.8434C2.31519 43.0782 2.50736 43.2704 2.74223 43.2704C2.97711 43.2704 3.16928 43.0782 3.16928 42.8434C3.16928 42.6085 2.97711 42.4163 2.74223 42.4163ZM4.02337 43.2704C4.25824 43.2704 4.45041 43.0782 4.45041 42.8434C4.45041 42.6085 4.25824 42.4163 4.02337 42.4163C3.78849 42.4163 3.59632 42.6085 3.59632 42.8434C3.59632 43.0782 3.78849 43.2704 4.02337 43.2704ZM4.02337 43.6975C3.78849 43.6975 3.59632 43.8896 3.59632 44.1245C3.59632 44.3594 3.78849 44.5515 4.02337 44.5515C4.25824 44.5515 4.45041 44.3594 4.45041 44.1245C4.45041 43.8896 4.25824 43.6975 4.02337 43.6975ZM4.02337 44.9786C3.78849 44.9786 3.59632 45.1708 3.59632 45.4056C3.59632 45.6405 3.78849 45.8327 4.02337 45.8327C4.25824 45.8327 4.45041 45.6405 4.45041 45.4056C4.45041 45.1708 4.25824 44.9786 4.02337 44.9786Z",
				fill: "#6C75AC"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragTextZone",
				d: "M20.5298 40.9216H9.78967C9.08213 40.9216 8.50854 41.4952 8.50854 42.2028V46.0462C8.50854 46.7537 9.08213 47.3273 9.78967 47.3273H20.5298C21.2374 47.3273 21.8109 46.7537 21.8109 46.0462V42.2028C21.8109 41.4952 21.2374 40.9216 20.5298 40.9216Z",
				fill: "#404772"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask3_10849_900175",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 46,
				y: 41,
				width: 10,
				height: 6,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M52.815 41.5623H48.7153C47.3002 41.5623 46.1531 42.7094 46.1531 44.1245C46.1531 45.5396 47.3002 46.6868 48.7153 46.6868H52.815C54.2301 46.6868 55.3772 45.5396 55.3772 44.1245C55.3772 42.7094 54.2301 41.5623 52.815 41.5623Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask3_10849_900175)",
				children: [/* @__PURE__ */ _jsx("path", {
					className: "switch",
					d: "M52.815 41.5623H48.7153C47.3002 41.5623 46.1531 42.7094 46.1531 44.1245C46.1531 45.5396 47.3002 46.6868 48.7153 46.6868H52.815C54.2301 46.6868 55.3772 45.5396 55.3772 44.1245C55.3772 42.7094 54.2301 41.5623 52.815 41.5623Z",
					fill: "#6674CC"
				}), /* @__PURE__ */ _jsx("g", {
					filter: "url(#filter3_dd_10849_900175)",
					children: /* @__PURE__ */ _jsx("path", {
						className: "switchDot",
						d: "M52.8142 46.1743C53.9463 46.1743 54.864 45.2566 54.864 44.1245C54.864 42.9924 53.9463 42.0747 52.8142 42.0747C51.6821 42.0747 50.7644 42.9924 50.7644 44.1245C50.7644 45.2566 51.6821 46.1743 52.8142 46.1743Z",
						fill: "#CED1E3"
					})
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemBorder",
				d: "M57.9383 38.8398H3.06299C1.55944 38.8398 0.340576 40.0587 0.340576 41.5623V46.6868C0.340576 48.1904 1.55944 49.4092 3.06299 49.4092H57.9383C59.4418 49.4092 60.6607 48.1904 60.6607 46.6868V41.5623C60.6607 40.0587 59.4418 38.8398 57.9383 38.8398Z",
				stroke: "#404772",
				strokeWidth: .320284
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemBody",
				d: "M121.938 51.3309H67.063C65.5594 51.3309 64.3406 52.5498 64.3406 54.0533V59.1779C64.3406 60.6815 65.5594 61.9003 67.063 61.9003H121.938C123.442 61.9003 124.661 60.6815 124.661 59.1779V54.0533C124.661 52.5498 123.442 51.3309 121.938 51.3309Z",
				fill: "#373D62"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemZone",
				d: "M64.5007 54.0533C64.5007 52.6382 65.6479 51.491 67.063 51.491H69.9455V61.7401H67.063C65.6479 61.7401 64.5007 60.5929 64.5007 59.1778V54.0533Z",
				fill: "#404772"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask4_10849_900175",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 64,
				y: 54,
				width: 6,
				height: 6,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M69.9456 54.0533H64.821V59.1779H69.9456V54.0533Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask4_10849_900175)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "dragDots",
					d: "M67.1693 57.8968C67.1693 58.1317 66.9772 58.3239 66.7423 58.3239C66.5074 58.3239 66.3152 58.1317 66.3152 57.8968C66.3152 57.6619 66.5074 57.4698 66.7423 57.4698C66.9772 57.4698 67.1693 57.6619 67.1693 57.8968ZM66.7423 56.1886C66.5074 56.1886 66.3152 56.3808 66.3152 56.6157C66.3152 56.8506 66.5074 57.0427 66.7423 57.0427C66.9772 57.0427 67.1693 56.8506 67.1693 56.6157C67.1693 56.3808 66.9772 56.1886 66.7423 56.1886ZM66.7423 54.9075C66.5074 54.9075 66.3152 55.0997 66.3152 55.3346C66.3152 55.5694 66.5074 55.7616 66.7423 55.7616C66.9772 55.7616 67.1693 55.5694 67.1693 55.3346C67.1693 55.0997 66.9772 54.9075 66.7423 54.9075ZM68.0234 55.7616C68.2583 55.7616 68.4505 55.5694 68.4505 55.3346C68.4505 55.0997 68.2583 54.9075 68.0234 54.9075C67.7885 54.9075 67.5964 55.0997 67.5964 55.3346C67.5964 55.5694 67.7885 55.7616 68.0234 55.7616ZM68.0234 56.1886C67.7885 56.1886 67.5964 56.3808 67.5964 56.6157C67.5964 56.8506 67.7885 57.0427 68.0234 57.0427C68.2583 57.0427 68.4505 56.8506 68.4505 56.6157C68.4505 56.3808 68.2583 56.1886 68.0234 56.1886ZM68.0234 57.4698C67.7885 57.4698 67.5964 57.6619 67.5964 57.8968C67.5964 58.1317 67.7885 58.3239 68.0234 58.3239C68.2583 58.3239 68.4505 58.1317 68.4505 57.8968C68.4505 57.6619 68.2583 57.4698 68.0234 57.4698Z",
					fill: "#6C75AC"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragTextZone",
				d: "M84.5298 53.4127H73.7897C73.0821 53.4127 72.5085 53.9863 72.5085 54.6938V58.5373C72.5085 59.2448 73.0821 59.8184 73.7897 59.8184H84.5298C85.2374 59.8184 85.811 59.2448 85.811 58.5373V54.6938C85.811 53.9863 85.2374 53.4127 84.5298 53.4127Z",
				fill: "#404772"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask5_10849_900175",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 110,
				y: 54,
				width: 10,
				height: 6,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M116.815 54.0533H112.715C111.3 54.0533 110.153 55.2005 110.153 56.6156C110.153 58.0307 111.3 59.1779 112.715 59.1779H116.815C118.23 59.1779 119.377 58.0307 119.377 56.6156C119.377 55.2005 118.23 54.0533 116.815 54.0533Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask5_10849_900175)",
				children: [/* @__PURE__ */ _jsx("path", {
					className: "switch",
					d: "M116.815 54.0533H112.715C111.3 54.0533 110.153 55.2005 110.153 56.6156C110.153 58.0307 111.3 59.1779 112.715 59.1779H116.815C118.23 59.1779 119.377 58.0307 119.377 56.6156C119.377 55.2005 118.23 54.0533 116.815 54.0533Z",
					fill: "#6674CC"
				}), /* @__PURE__ */ _jsx("g", {
					filter: "url(#filter4_dd_10849_900175)",
					children: /* @__PURE__ */ _jsx("path", {
						className: "switchDot",
						d: "M116.814 58.6654C117.946 58.6654 118.864 57.7477 118.864 56.6156C118.864 55.4835 117.946 54.5658 116.814 54.5658C115.682 54.5658 114.764 55.4835 114.764 56.6156C114.764 57.7477 115.682 58.6654 116.814 58.6654Z",
						fill: "#CED1E3"
					})
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemBorder",
				d: "M121.938 51.3309H67.063C65.5594 51.3309 64.3406 52.5498 64.3406 54.0533V59.1779C64.3406 60.6815 65.5594 61.9003 67.063 61.9003H121.938C123.442 61.9003 124.661 60.6815 124.661 59.1779V54.0533C124.661 52.5498 123.442 51.3309 121.938 51.3309Z",
				stroke: "#404772",
				strokeWidth: .320284
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemBody",
				d: "M121.938 76.3309H67.063C65.5594 76.3309 64.3406 77.5498 64.3406 79.0533V84.1779C64.3406 85.6815 65.5594 86.9003 67.063 86.9003H121.938C123.442 86.9003 124.661 85.6815 124.661 84.1779V79.0533C124.661 77.5498 123.442 76.3309 121.938 76.3309Z",
				fill: "#373D62"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemZone",
				d: "M64.5007 79.0533C64.5007 77.6382 65.6479 76.491 67.063 76.491H69.9455V86.7401H67.063C65.6479 86.7401 64.5007 85.5929 64.5007 84.1778V79.0533Z",
				fill: "#404772"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask6_10849_900175",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 64,
				y: 79,
				width: 6,
				height: 6,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M69.9456 79.0533H64.821V84.1779H69.9456V79.0533Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask6_10849_900175)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "dragDots",
					d: "M67.1693 82.8968C67.1693 83.1317 66.9772 83.3239 66.7423 83.3239C66.5074 83.3239 66.3152 83.1317 66.3152 82.8968C66.3152 82.6619 66.5074 82.4698 66.7423 82.4698C66.9772 82.4698 67.1693 82.6619 67.1693 82.8968ZM66.7423 81.1886C66.5074 81.1886 66.3152 81.3808 66.3152 81.6157C66.3152 81.8506 66.5074 82.0427 66.7423 82.0427C66.9772 82.0427 67.1693 81.8506 67.1693 81.6157C67.1693 81.3808 66.9772 81.1886 66.7423 81.1886ZM66.7423 79.9075C66.5074 79.9075 66.3152 80.0997 66.3152 80.3346C66.3152 80.5694 66.5074 80.7616 66.7423 80.7616C66.9772 80.7616 67.1693 80.5694 67.1693 80.3346C67.1693 80.0997 66.9772 79.9075 66.7423 79.9075ZM68.0234 80.7616C68.2583 80.7616 68.4505 80.5694 68.4505 80.3346C68.4505 80.0997 68.2583 79.9075 68.0234 79.9075C67.7885 79.9075 67.5964 80.0997 67.5964 80.3346C67.5964 80.5694 67.7885 80.7616 68.0234 80.7616ZM68.0234 81.1886C67.7885 81.1886 67.5964 81.3808 67.5964 81.6157C67.5964 81.8506 67.7885 82.0427 68.0234 82.0427C68.2583 82.0427 68.4505 81.8506 68.4505 81.6157C68.4505 81.3808 68.2583 81.1886 68.0234 81.1886ZM68.0234 82.4698C67.7885 82.4698 67.5964 82.6619 67.5964 82.8968C67.5964 83.1317 67.7885 83.3239 68.0234 83.3239C68.2583 83.3239 68.4505 83.1317 68.4505 82.8968C68.4505 82.6619 68.2583 82.4698 68.0234 82.4698Z",
					fill: "#6C75AC"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragTextZone",
				d: "M84.5298 78.4127H73.7897C73.0821 78.4127 72.5085 78.9863 72.5085 79.6939V83.5373C72.5085 84.2448 73.0821 84.8184 73.7897 84.8184H84.5298C85.2374 84.8184 85.811 84.2448 85.811 83.5373V79.6939C85.811 78.9863 85.2374 78.4127 84.5298 78.4127Z",
				fill: ""
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask7_10849_900175",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 110,
				y: 79,
				width: 10,
				height: 6,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M116.815 79.0533H112.715C111.3 79.0533 110.153 80.2005 110.153 81.6156C110.153 83.0307 111.3 84.1779 112.715 84.1779H116.815C118.23 84.1779 119.377 83.0307 119.377 81.6156C119.377 80.2005 118.23 79.0533 116.815 79.0533Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask7_10849_900175)",
				children: [/* @__PURE__ */ _jsx("path", {
					className: "switch",
					d: "M116.815 79.0533H112.715C111.3 79.0533 110.153 80.2005 110.153 81.6156C110.153 83.0307 111.3 84.1779 112.715 84.1779H116.815C118.23 84.1779 119.377 83.0307 119.377 81.6156C119.377 80.2005 118.23 79.0533 116.815 79.0533Z",
					fill: "#6674CC"
				}), /* @__PURE__ */ _jsx("g", {
					filter: "url(#filter5_dd_10849_900175)",
					children: /* @__PURE__ */ _jsx("path", {
						className: "switchDot",
						d: "M116.814 83.6654C117.946 83.6654 118.864 82.7477 118.864 81.6156C118.864 80.4835 117.946 79.5658 116.814 79.5658C115.682 79.5658 114.764 80.4835 114.764 81.6156C114.764 82.7477 115.682 83.6654 116.814 83.6654Z",
						fill: "#CED1E3"
					})
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemBorder",
				d: "M121.938 76.3309H67.063C65.5594 76.3309 64.3406 77.5498 64.3406 79.0533V84.1779C64.3406 85.6815 65.5594 86.9003 67.063 86.9003H121.938C123.442 86.9003 124.661 85.6815 124.661 84.1779V79.0533C124.661 77.5498 123.442 76.3309 121.938 76.3309Z",
				stroke: "#404772",
				strokeWidth: .320284
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemBody",
				d: "M121.938 88.8398H67.063C65.5594 88.8398 64.3406 90.0587 64.3406 91.5623V96.6868C64.3406 98.1904 65.5594 99.4092 67.063 99.4092H121.938C123.442 99.4092 124.661 98.1904 124.661 96.6868V91.5623C124.661 90.0587 123.442 88.8398 121.938 88.8398Z",
				fill: "#373D62"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemZone",
				d: "M64.5007 91.5622C64.5007 90.1471 65.6479 88.9999 67.063 88.9999H69.9455V99.249H67.063C65.6479 99.249 64.5007 98.1018 64.5007 96.6867V91.5622Z",
				fill: "#404772"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragDots",
				d: "M67.1693 95.4056C67.1693 95.6405 66.9772 95.8327 66.7423 95.8327C66.5074 95.8327 66.3152 95.6405 66.3152 95.4056C66.3152 95.1708 66.5074 94.9786 66.7423 94.9786C66.9772 94.9786 67.1693 95.1708 67.1693 95.4056ZM66.7423 93.6975C66.5074 93.6975 66.3152 93.8896 66.3152 94.1245C66.3152 94.3594 66.5074 94.5515 66.7423 94.5515C66.9772 94.5515 67.1693 94.3594 67.1693 94.1245C67.1693 93.8896 66.9772 93.6975 66.7423 93.6975ZM66.7423 92.4163C66.5074 92.4163 66.3152 92.6085 66.3152 92.8434C66.3152 93.0782 66.5074 93.2704 66.7423 93.2704C66.9772 93.2704 67.1693 93.0782 67.1693 92.8434C67.1693 92.6085 66.9772 92.4163 66.7423 92.4163ZM68.0234 93.2704C68.2583 93.2704 68.4505 93.0782 68.4505 92.8434C68.4505 92.6085 68.2583 92.4163 68.0234 92.4163C67.7885 92.4163 67.5964 92.6085 67.5964 92.8434C67.5964 93.0782 67.7885 93.2704 68.0234 93.2704ZM68.0234 93.6975C67.7885 93.6975 67.5964 93.8896 67.5964 94.1245C67.5964 94.3594 67.7885 94.5515 68.0234 94.5515C68.2583 94.5515 68.4505 94.3594 68.4505 94.1245C68.4505 93.8896 68.2583 93.6975 68.0234 93.6975ZM68.0234 94.9786C67.7885 94.9786 67.5964 95.1708 67.5964 95.4056C67.5964 95.6405 67.7885 95.8327 68.0234 95.8327C68.2583 95.8327 68.4505 95.6405 68.4505 95.4056C68.4505 95.1708 68.2583 94.9786 68.0234 94.9786Z",
				fill: "#6C75AC"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragTextZone",
				d: "M84.5298 90.9216H73.7897C73.0821 90.9216 72.5085 91.4952 72.5085 92.2028V96.0462C72.5085 96.7537 73.0821 97.3273 73.7897 97.3273H84.5298C85.2374 97.3273 85.811 96.7537 85.811 96.0462V92.2028C85.811 91.4952 85.2374 90.9216 84.5298 90.9216Z",
				fill: "#404772"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask8_10849_900175",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 110,
				y: 91,
				width: 10,
				height: 6,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M116.815 91.5623H112.715C111.3 91.5623 110.153 92.7094 110.153 94.1245C110.153 95.5396 111.3 96.6868 112.715 96.6868H116.815C118.23 96.6868 119.377 95.5396 119.377 94.1245C119.377 92.7094 118.23 91.5623 116.815 91.5623Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask8_10849_900175)",
				children: [/* @__PURE__ */ _jsx("path", {
					className: "switch",
					d: "M116.815 91.5623H112.715C111.3 91.5623 110.153 92.7094 110.153 94.1245C110.153 95.5396 111.3 96.6868 112.715 96.6868H116.815C118.23 96.6868 119.377 95.5396 119.377 94.1245C119.377 92.7094 118.23 91.5623 116.815 91.5623Z",
					fill: "#6674CC"
				}), /* @__PURE__ */ _jsx("g", {
					filter: "url(#filter6_dd_10849_900175)",
					children: /* @__PURE__ */ _jsx("path", {
						className: "switchDot",
						d: "M116.814 96.1743C117.946 96.1743 118.864 95.2566 118.864 94.1245C118.864 92.9924 117.946 92.0747 116.814 92.0747C115.682 92.0747 114.764 92.9924 114.764 94.1245C114.764 95.2566 115.682 96.1743 116.814 96.1743Z",
						fill: "#CED1E3"
					})
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "dragItemBorder",
				d: "M121.938 88.8398H67.063C65.5594 88.8398 64.3406 90.0587 64.3406 91.5623V96.6868C64.3406 98.1904 65.5594 99.4092 67.063 99.4092H121.938C123.442 99.4092 124.661 98.1904 124.661 96.6868V91.5623C124.661 90.0587 123.442 88.8398 121.938 88.8398Z",
				stroke: "#404772",
				strokeWidth: .320284
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "arrow",
				d: "M32.6073 24.4298L35.6858 19.5456L29.9167 19.3216L32.6073 24.4298ZM33.4481 21.5072C33.5855 20.8985 33.7677 20.2611 34.0009 19.6043L33.0585 19.2698C32.8121 19.9639 32.6188 20.6395 32.4726 21.2871L33.4481 21.5072ZM34.7677 17.7712C35.0462 17.1949 35.3645 16.611 35.7263 16.0251L34.8754 15.4998C34.4954 16.1153 34.1605 16.7293 33.8673 17.3362L34.7677 17.7712ZM36.8557 14.3835C37.2466 13.8709 37.6733 13.3606 38.1384 12.8565L37.4034 12.1784C36.917 12.7057 36.4701 13.2399 36.0605 13.7772L36.8557 14.3835ZM39.5553 11.4525C40.0342 11.018 40.5452 10.5909 41.0901 10.174L40.4824 9.37984C39.9154 9.81367 39.383 10.2586 38.8833 10.7119L39.5553 11.4525ZM42.729 9.01991C43.2737 8.66706 43.8467 8.3242 44.4492 7.99321L43.9678 7.11675C43.3443 7.45925 42.7505 7.81449 42.1853 8.18063L42.729 9.01991ZM46.2425 7.08598C46.8328 6.81145 47.4477 6.54784 48.0882 6.29653L47.7229 5.36563C47.0637 5.6243 46.43 5.89594 45.8208 6.17925L46.2425 7.08598ZM49.9861 5.61383C50.6085 5.40932 51.2523 5.21588 51.9183 5.03451L51.6555 4.06966C50.9733 4.25546 50.313 4.45383 49.674 4.6638L49.9861 5.61383ZM53.8735 4.55188C54.5145 4.40934 55.1741 4.27747 55.8528 4.15702L55.678 3.17241C54.9855 3.29532 54.3117 3.43 53.6564 3.57573L53.8735 4.55188ZM57.8496 3.84385C58.1833 3.79817 58.5212 3.75513 58.8635 3.7148L58.7464 2.72168C58.3981 2.76273 58.0539 2.80656 57.714 2.85309L57.8496 3.84385ZM58.8635 3.7148C59.1904 3.67628 59.5139 3.64175 59.8342 3.61113L59.739 2.61567C59.4114 2.647 59.0805 2.68231 58.7464 2.72168L58.8635 3.7148ZM61.7579 3.4714C62.4147 3.43919 63.0565 3.42402 63.6836 3.42497L63.6851 2.42497C63.0408 2.42399 62.3822 2.43959 61.7089 2.4726L61.7579 3.4714ZM65.6059 3.48C66.2602 3.51701 66.8971 3.57228 67.5173 3.64465L67.6332 2.65139C66.9929 2.57668 66.3361 2.51971 65.6623 2.4816L65.6059 3.48ZM69.4174 3.92813C70.0625 4.04611 70.6877 4.18339 71.2934 4.3384L71.5413 3.36962C70.9129 3.20879 70.265 3.06656 69.5972 2.94444L69.4174 3.92813ZM73.1278 4.88023C73.7461 5.08835 74.342 5.31576 74.9159 5.56045L75.3081 4.64057C74.7101 4.38561 74.0898 4.1489 73.4467 3.93247L73.1278 4.88023ZM76.6424 6.38103C77.2174 6.68386 77.7672 7.00471 78.293 7.34105L78.8319 6.49865C78.2826 6.1473 77.7085 5.8123 77.1086 5.49628L76.6424 6.38103ZM79.8552 8.43705C80.3699 8.83222 80.8577 9.24248 81.3193 9.66466L81.9942 8.92672C81.5118 8.48554 81.0021 8.05679 80.4641 7.64381L79.8552 8.43705ZM82.6714 11.0119C83.1109 11.4888 83.5213 11.9758 83.9041 12.4688L84.694 11.8556C84.2945 11.341 83.8658 10.8325 83.4068 10.3343L82.6714 11.0119ZM85.0117 14.0259C85.3677 14.5734 85.6922 15.1232 85.9864 15.67L86.867 15.1961C86.56 14.6256 86.2215 14.052 85.8499 13.4807L85.0117 14.0259ZM86.82 17.3879C87.0842 17.9962 87.3112 18.5933 87.5036 19.1714L88.4524 18.8556C88.2508 18.2497 88.0133 17.6251 87.7374 16.9896L86.82 17.3879ZM88.0166 21.0051C88.0885 21.3244 88.1486 21.6333 88.1973 21.9298L89.184 21.7678C89.132 21.4512 89.0682 21.1232 88.9922 20.7854L88.0166 21.0051Z",
				fill: "#5362C6"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_dd_10849_900175",
			x: 56.7644,
			y: 26.0747,
			width: 10.0996,
			height: 10.0996,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_10849_900175"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_10849_900175",
					result: "effect2_dropShadow_10849_900175"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_10849_900175",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter1_dd_10849_900175",
			x: 111.764,
			y: 40.0747,
			width: 10.0996,
			height: 10.0996,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_10849_900175"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_10849_900175",
					result: "effect2_dropShadow_10849_900175"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_10849_900175",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter2_dd_10849_900175",
			x: 111.764,
			y: 65.0747,
			width: 10.0996,
			height: 10.0996,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_10849_900175"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_10849_900175",
					result: "effect2_dropShadow_10849_900175"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_10849_900175",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter3_dd_10849_900175",
			x: 47.7644,
			y: 40.0747,
			width: 10.0996,
			height: 10.0996,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_10849_900175"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_10849_900175",
					result: "effect2_dropShadow_10849_900175"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_10849_900175",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter4_dd_10849_900175",
			x: 111.764,
			y: 52.5658,
			width: 10.0996,
			height: 10.0996,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_10849_900175"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_10849_900175",
					result: "effect2_dropShadow_10849_900175"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_10849_900175",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter5_dd_10849_900175",
			x: 111.764,
			y: 77.5658,
			width: 10.0996,
			height: 10.0996,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_10849_900175"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_10849_900175",
					result: "effect2_dropShadow_10849_900175"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_10849_900175",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter6_dd_10849_900175",
			x: 111.764,
			y: 90.0747,
			width: 10.0996,
			height: 10.0996,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_10849_900175"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_10849_900175",
					result: "effect2_dropShadow_10849_900175"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_10849_900175",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_10849_900175",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 125,
				height: 100,
				fill: "white",
				transform: "translate(0.166748)"
			})
		})
	] })]
});
export default SvgDragDropLeft;
